import { SideNavigationComponent } from './side-navigation/side-navigation.component';
import { MobileNavigationComponent } from './mobile-navigation/mobile-navigation.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LinkComponent as MobileLinkComponent } from './mobile-navigation/link/link.component';
import { LinkComponent as SidebarLinkComponent } from './side-navigation/link/link.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
      CommonModule,
      RouterModule,
      MatIconModule,
      MatSidenavModule,
      MatTooltipModule
    ],
  declarations: [
      MobileLinkComponent,
      MobileNavigationComponent,
      SidebarLinkComponent,
      SideNavigationComponent,
    ],
  exports: [
      MobileNavigationComponent,
      SideNavigationComponent,
      MobileLinkComponent,
    ],
})
export class NavigationModule { }
